import { http } from "./client";

// Dashboard widgets (both views) and their admin screens:
// announcements, upcoming birthdays, holidays. Every function returns the body.
const data = (r) => r.data;
const clean = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, v]) => v !== undefined && v !== null && v !== "" && v !== false,
    ),
  );

export const widgetsApi = {
  // → { announcements: Feed[] | null, birthdays: Birthday[] | null, holidays: Upcoming[] | null } (5 each; a failed card is null)
  // companyId / branchId narrow the birthdays only
  all: (params) =>
    http.get("/dashboard/widgets", { params: clean(params) }).then(data),
  // → { employees, recentHires, recentHiresSince, days }; no companyId = whole scope (super admin: every company)
  headcount: (params) =>
    http.get("/dashboard/headcount", { params: clean(params) }).then(data),
  // Attendance view; same scope as headcount →
  // { date, holiday|null, expected, checkedIn, present, late, halfDay, checkedInNow, onLeave,
  //   notCheckedIn, byType: { Internal?: { expected, checkedIn }, Deployed?: {…} },
  //   onLeaveList: [{ employeeId, name, branchName, leaveType, from, until }] (≤50) }
  // In scope, no check-in today and not on leave →
  // { date, data: [{ employeeId, employeeNumber, name, assignmentType, branchName, companyName }], total, page, limit }
  notCheckedIn: (params) =>
    http
      .get("/dashboard/attendance-today/not-checked-in", {
        params: clean(params),
      })
      .then(data),
  attendanceToday: (params) =>
    http
      .get("/dashboard/attendance-today", { params: clean(params) })
      .then(data),
  // → [{ employeeId, name, branchName, companyName, date, daysAway, photoUrl }]
  birthdays: (params) =>
    http.get("/dashboard/birthdays", { params: clean(params) }).then(data),
};

/* ---------- Announcements (module announcements) ---------- */
export const announcementsApi = {
  // Feed: [{ id, title, body, priority, pinned, publishAt, expiresAt, companyName, createdBy: { name } }]
  feed: (limit = 5) =>
    http.get("/announcements/feed", { params: { limit } }).then(data),
  // { data: Row[], total, page, limit }; Row = Feed + { companyId, branchIds, isActive, status, createdAt, updatedAt }
  list: (params) =>
    http.get("/announcements", { params: clean(params) }).then(data),
  create: (body) => http.post("/announcements", body).then(data),
  update: (id, body) => http.patch(`/announcements/${id}`, body).then(data),
  remove: (id) => http.delete(`/announcements/${id}`).then(data),
};

/* ---------- Holidays (module holidays) ---------- */
export const holidaysApi = {
  // [{ id, date, name, type, scope: NATIONAL|COMPANY|BRANCH, daysAway }]
  upcoming: (limit = 5) =>
    http.get("/holidays/upcoming", { params: { limit } }).then(data),
  range: (from, to) =>
    http.get("/holidays", { params: clean({ from, to }) }).then(data),
  // { data: AdminRow[], total, page, limit, year }; AdminRow = Upcoming + { companyId, companyName, branchIds, isDraft, remarks }
  manage: (params) =>
    http.get("/holidays/manage", { params: clean(params) }).then(data),
  create: (body) => http.post("/holidays", body).then(data),
  update: (id, body) => http.patch(`/holidays/${id}`, body).then(data),
  remove: (id) => http.delete(`/holidays/${id}`).then(data),
  // → { created, skipped, skippedItems: [{ date, name, reason: MOVABLE|EXISTS|NO_FEB_29 }] }
  copyYear: (body) => http.post("/holidays/copy-year", body).then(data),
};
